import EnergyInformation from "./EnergyInformation";

export default EnergyInformation;